import React, { useState, useEffect, useContext, useCallback } from 'react';
import { toast } from "react-toastify";
import { apiConfig } from "../../commonFunction/apiconfig";
import { UserContext } from "../../context/userContext";
import axios from "axios";
import styles from './BannerManager.module.css';
import Loader from "../../components/loader";


const BannerManager = () => {
  const { userToken } = useContext(UserContext);
  const [banners, setBanners] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchBanners = useCallback(async () => {
    if (!userToken) return;
    try {
      const headers = {
        token: userToken,
      };
      setLoading(true);
      const res = await axios.get(
        `${apiConfig.fetchBanner}`,
        { headers }
      );
      const resData = res?.data?.result;
      setLoading(false);
      setBanners(resData);
    } catch (error) {
      console.log(error);
      setBanners([]);
      setLoading(false);
    }
  }, [userToken]);

  useEffect(() => {
    fetchBanners();
  }, [fetchBanners]);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) return;
  
    const reader = new FileReader();
    reader.onload = async () => {
      const base64Image = reader.result;
  
      try {
        setLoading(true);
        const headers = {
          token: userToken,
        };
  
        const response = await axios.post(apiConfig.addBanner, {
          img: base64Image,
        }, { headers });
  
        if (response.data.statusCode === 200) {
          setLoading(false);
          toast.success("Banner uploaded successfully");
          fetchBanners();
          setSelectedFile(null);
          document.getElementById("fileInput").value = "";
        } else {
          toast.error("Failed to upload Banner");
        }
      } catch (error) {
        console.error('Error uploading banner:', error);
        toast.error("An error occurred while uploading the banner");
      }
    };
  
    reader.readAsDataURL(selectedFile);
  };
  

  const handleDelete = async (id) => {
    try {
      setLoading(true);
      const headers = {
        token: userToken,
      };
      const response = await axios.post(`${apiConfig.deleteBanner}?_id=${id}`, {
      }, { headers });
      if (response.data.statusCode === 200) {
        setLoading(false);
        toast.success("Banner Delete successfully");
        fetchBanners();
      } else {
        toast.error("Failed to delete Banner");
      }
    } catch (error) {
      console.error('Error deleting banner:', error);
    }
  };


  return (
    <div className={styles.bannerManager}>
    <h2>Banner Management</h2>
    <div className={styles.uploadSection}>
      <input
        id="fileInput"
        type="file"
        accept="image/*"
        onChange={handleFileChange}
      />
      <button onClick={handleUpload}>Upload Banner</button>
    </div>
  
    {loading ? (
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "100px",
        }}
      >
        <Loader width={"100px"} height={"100px"} />
      </div>
    ) : (
      <>
        {(!banners || banners?.length === 0) ? (
          <p
            style={{
              textAlign: "center",
              marginTop: "40px",
              fontWeight: "bold",
            }}
          >
            No banners Found
          </p>
        ) : (
          <div className={styles.bannerList}>
            {banners.map((banner) => (
              <div key={banner._id} className={styles.bannerCard}>
                <img src={banner.img} alt="Banner" />
                <div className={styles.actions}>
                  <button onClick={() => handleDelete(banner._id)}>Delete</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </>
    )}
  </div>
  
  );
};

export default BannerManager;
